/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserEmail
 */
export interface MelcoModelsUserEmail {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserEmail
     */
    email_address?: string | null;
}

export function MelcoModelsUserEmailFromJSON(json: any): MelcoModelsUserEmail {
    return MelcoModelsUserEmailFromJSONTyped(json, false);
}

export function MelcoModelsUserEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
    };
}

export function MelcoModelsUserEmailToJSON(value?: MelcoModelsUserEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email_address': value.email_address,
    };
}


